import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button, IconButton, TextField, Typography, Box, Chip } from '@mui/material';
import { Edit3, Eye, Trash2 } from 'react-feather';
import '../../styles/table.css';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { User } from 'react-feather';
import { Users } from 'react-feather';
import { Link } from 'react-router-dom';
import { authApi } from '../../api/api';
import { useSelector } from 'react-redux';
import { logout } from '../../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import Toastmessage from '../../components/Toast'


export default function FirmList({ apiResponse }) {
    const [rows, setRows] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]); // Store filtered data
    const [searchText, setSearchText] = useState('');
    const [open, setOpen] = useState(false);
    const [deleteSub, setDeleteSub] = useState('');

    const token = useSelector((state) => state.auth.token); // Get the token from Redux
    const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        if (apiResponse?.data?.actions?.list) {
            fetchsub();
        }
    }, [token, userID]); // Run effect when token or userID changes


    // Define fetchFirm separately to reuse it
    const fetchsub = async () => {
        const input_token = 'SUBSCRIPTION_LIST'; // Replace with your actual token
        const apiUrl = 'list_of_subscription'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);
            if (data && data.success) {
                setRows(data.subscription_list);
                setFilteredRows(data.subscription_list); // Set filtered rows to the same data initially
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    const handleClickOpen = (id) => {
        setOpen(true);
        setDeleteSub(id);
    };


    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = async () => {


        const fetchData = async () => {
            const input_token = deleteSub + 'DELETE_SUBS';; // Replace with your actual token
            const apiUrl = 'delete_subscription'; // Replace with the actual API endpoint

            const dataInput = {
                id: deleteSub,
                login_user_id: userID
            };
            try {
                const data = await authApi(input_token, dataInput, apiUrl, token);

                if (data && data.success) {
                    await Toastmessage(data.message, true);
                    setOpen(false);
                    await fetchsub(); // Refresh the list after deletion
                } else if (data && data.message === 'Token has expired') {
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else if (data === undefined) {
                    await Toastmessage('No response from server', false);
                } else {
                    await Toastmessage(data?.message || 'An error occurred', false);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else {
                    await Toastmessage('Something went wrong', false);
                }
            }
        }

        // Call the function to make the API call
        await fetchData();
    };

    const handleClickEdit = (id) => {
        navigate('/editsubscriptions', { state: { subscriptionsId: id } });
    };

    const handleClickView = (id) => {
        navigate('/viewsubscriptions', { state: { subscriptionsId: id } });
    }

    const columns = [
        { field: 'subscription_name', headerName: 'Subscriptions Name', flex: 1.4, renderCell: (params) => <p style={{ fontWeight: 'bold', color: '#3570FF' }}>{params.value}</p> },
        {
            field: 'modules', headerName: 'Access Modules', flex: 2, renderCell: (params) => (
                <>
                    {params.value.map((module, index) => (
                        <Chip key={index} label={module} style={{ marginRight: 4, backgroundColor: 'var(--action-icon-bg)', color: '#00AC69' }} />
                    ))}
                </>
            ),
        },
        { field: 'total_subscribed', headerName: 'Total Subscribed', flex: 1, },
        {
            field: 'status', headerName: 'Status', flex: 1, renderCell: (params) => {
                return (
                    <div>
                        {params.row.status == 1 ? 'Active' : 'Inctive'}
                    </div>
                )
            }
        },
        {
            field: 'actions',
            headerName: 'Actions',
            flex: 0.8,
            renderCell: (params) => (
                <>
                    {apiResponse?.data?.actions?.view && (
                        <IconButton
                            onClick={() => handleClickView(`${params.row.id}`)}
                            sx={{
                                backgroundColor: 'var(--action-icon-bg)',
                                color: 'var(--action-icon-color)',
                                borderRadius: '50%',
                                padding: '8px',
                                marginRight: '8px',
                            }}
                            size="small"
                        >
                            <Eye size={16} />
                        </IconButton>
                    )}
                    {apiResponse?.data?.actions?.edit && (
                        <IconButton
                            onClick={() => handleClickEdit(`${params.row.id}`)}
                            sx={{
                                backgroundColor: 'var(--action-icon-bg)',
                                color: 'var(--action-icon-color)',
                                borderRadius: '50%',
                                padding: '8px',
                                marginRight: '8px',
                            }}
                            size="small"
                        >
                            <Edit3 size={16} />
                        </IconButton>
                    )}
                    {apiResponse?.data?.actions?.delete && (
                        <IconButton
                            onClick={() => handleClickOpen(params.row.id)}
                            sx={{
                                backgroundColor: 'var(--action-icon-bg)',
                                color: 'var(--action-icon-color)',
                                borderRadius: '50%',
                                padding: '8px',
                            }}
                            size="small"
                        >
                            <Trash2 size={16} />
                        </IconButton>
                    )}
                </>
            ),
        },
    ];


    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchText(value);

        // Search all fields in rows
        const filteredData = rows.filter((row) =>
            Object.values(row).some((field) =>
                String(field).toLowerCase().includes(value)
            )
        );
        setFilteredRows(filteredData); // Update filtered rows
    };

    const clearSearch = () => {
        setSearchText('');
        setFilteredRows(rows); // Reset to original data
    }

    return (
        <Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="var(--text-color)">
                        Subscriptions  List
                    </Typography>
                </Box>

                {/* Right Section */}
                {apiResponse?.data?.actions?.add && (
                    <Button
                        variant="outlined"
                        component={Link}
                        to="/addsubscriptions"
                        sx={{
                            backgroundColor: 'var(--back-button)',
                            color: "var(--back-color)",
                            fontWeight: 'bold',
                            border: 'none',
                            padding: '10px 20px'
                        }}
                        startIcon={<Users sx={{ fontSize: 17 }} />}
                        style={{ textTransform: 'none' }}
                    >
                        Add New Subscriptions
                    </Button>
                )}
            </Box>

            <Box className="card-box" sx={{ p: 3, m: 3, borderRadius: '8px' }}>
                <Box display="flex" justifyContent="end" alignItems="center" mb={2}>
                    <Box sx={{ position: 'relative', width: '300px' }}> {/* Adjust width as needed */}
                        <TextField
                            label="Search"
                            variant="outlined"
                            value={searchText}
                            onChange={handleSearch}
                            className="search-input"
                            fullWidth
                            InputProps={{
                                endAdornment: searchText && (
                                    <span
                                        onClick={() => clearSearch()}
                                        style={{
                                            cursor: 'pointer',
                                            color: '#aaa',
                                            marginRight: '10px',
                                        }}
                                    >
                                        ✕
                                    </span>
                                ),
                            }}
                        />
                    </Box>
                </Box>
                <DataGrid
                    rows={filteredRows}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                    }}
                    className="data-grid"
                />
            </Box>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this subscription?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Disagree</Button>
                    <Button onClick={handleDelete} autoFocus>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}


